import React, { useState, useEffect } from 'react';
import { FiBarChart2, FiDownload, FiFilter, FiCalendar, FiUsers, FiTrendingUp } from 'react-icons/fi';
import { toast } from 'react-toastify';
import api from '../../services/api';
import './RelatorioPresencas.css';

const RelatorioPresencas = () => {
  const [relatorios, setRelatorios] = useState({
    resumoGeral: {
      totalReunioes: 0,
      totalPresencas: 0,
      mediaPresencas: 0,
      colaboradoresAtivos: 0
    },
    presencasPorMes: [],
    colaboradoresMaisPresentes: [],
    reunioesMaisFrequentadas: []
  });
  
  const [filtros, setFiltros] = useState({
    dataInicio: '',
    dataFim: '',
    cargo: '',
    status: 'todos'
  });
  
  const [loading, setLoading] = useState(true);
  const [cargos, setCargos] = useState([]);

  useEffect(() => {
    carregarDados();
  }, []);

  const carregarDados = async () => {
    try {
      const cargosRes = await api.get('/cargos');
      setCargos(cargosRes.data);
      await carregarRelatorios();
    } catch (error) {
      console.error('Erro ao carregar dados:', error);
      toast.error('Erro ao carregar dados');
    }
  };

  const carregarRelatorios = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams();
      if (filtros.dataInicio) params.set('dataInicio', filtros.dataInicio);
      if (filtros.dataFim) params.set('dataFim', filtros.dataFim);
      if (filtros.cargo) params.set('cargo', filtros.cargo);
      params.set('ano', new Date().getFullYear());
      const { data } = await api.get(`/dashboard/relatorio-presencas?${params.toString()}`);
      if (data.success && data.data) {
        setRelatorios(data.data);
      }
    } catch (error) {
      console.error('Erro ao carregar relatórios:', error);
      toast.error('Erro ao carregar relatórios');
    } finally {
      setLoading(false);
    }
  };

  const exportarRelatorio = () => {
    toast.info('Funcionalidade de exportação em desenvolvimento');
  };

  const aplicarFiltros = () => {
    carregarRelatorios();
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner">
          <FiBarChart2 className="spin" />
          <p>Carregando relatórios...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="relatorio-page">
      <div className="page-header">
        <div className="header-content">
          <h1>
            <FiBarChart2 className="page-icon" />
            Relatórios de Presença
          </h1>
          <p>Análise detalhada da frequência dos colaboradores</p>
        </div>
        <button className="btn-primary" onClick={exportarRelatorio}>
          <FiDownload /> Exportar PDF
        </button>
      </div>

      {/* Filtros */}
      <div className="filtros-section">
        <h2>Filtros</h2>
        <div className="filtros-grid">
          <div className="form-group">
            <label>Data Início</label>
            <input
              type="date"
              value={filtros.dataInicio}
              onChange={(e) => setFiltros(prev => ({ ...prev, dataInicio: e.target.value }))}
            />
          </div>
          <div className="form-group">
            <label>Data Fim</label>
            <input
              type="date"
              value={filtros.dataFim}
              onChange={(e) => setFiltros(prev => ({ ...prev, dataFim: e.target.value }))}
            />
          </div>
          <div className="form-group">
            <label>Cargo</label>
            <select
              value={filtros.cargo}
              onChange={(e) => setFiltros(prev => ({ ...prev, cargo: e.target.value }))}
            >
              <option value="">Todos os cargos</option>
              {cargos.map(cargo => (
                <option key={cargo.id} value={cargo.id}>
                  {cargo.nome}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <button className="btn-filter" onClick={aplicarFiltros}>
              <FiFilter /> Aplicar Filtros
            </button>
          </div>
        </div>
      </div>

      {/* Resumo Geral */}
      <div className="resumo-cards">
        <div className="stat-card">
          <div className="stat-icon">
            <FiCalendar />
          </div>
          <div className="stat-content">
            <span className="stat-number">{relatorios.resumoGeral.totalReunioes}</span>
            <span className="stat-label">Total de Reuniões</span>
          </div>
        </div>
        
        <div className="stat-card">
          <div className="stat-icon">
            <FiUsers />
          </div>
          <div className="stat-content">
            <span className="stat-number">{relatorios.resumoGeral.totalPresencas}</span>
            <span className="stat-label">Total de Presenças</span>
          </div>
        </div>
        
        <div className="stat-card">
          <div className="stat-icon">
            <FiTrendingUp />
          </div>
          <div className="stat-content">
            <span className="stat-number">{relatorios.resumoGeral.mediaPresencas}</span>
            <span className="stat-label">Média por Reunião</span>
          </div>
        </div>
        
        <div className="stat-card">
          <div className="stat-icon">
            <FiUsers />
          </div>
          <div className="stat-content">
            <span className="stat-number">{relatorios.resumoGeral.colaboradoresAtivos}</span>
            <span className="stat-label">Colaboradores Ativos</span>
          </div>
        </div>
      </div>

      <div className="relatorio-grid">
        {/* Gráfico de Presenças por Mês */}
        <div className="chart-card">
          <h3>Presenças por Mês</h3>
          <div className="chart-container">
            <div className="bar-chart">
              {relatorios.presencasPorMes.map((item, index) => {
                const maxP = Math.max(1, ...relatorios.presencasPorMes.map(i => i.presencas));
                return (
                  <div key={index} className="bar-item">
                    <div
                      className="bar"
                      style={{ height: `${(item.presencas / maxP) * 100}%` }}
                      title={`${item.mes}: ${item.presencas} presenças`}
                    />
                    <span className="bar-label">{item.mes}</span>
                    <span className="bar-value">{item.presencas}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* Colaboradores Mais Presentes */}
        <div className="ranking-card">
          <h3>Colaboradores Mais Presentes</h3>
          <div className="ranking-list">
            {relatorios.colaboradoresMaisPresentes.length === 0 ? (
              <p className="sem-dados">Nenhuma presença no período.</p>
            ) : relatorios.colaboradoresMaisPresentes.map((colaborador, index) => (
              <div key={index} className="ranking-item">
                <div className="ranking-position">{index + 1}º</div>
                <div className="ranking-info">
                  <span className="ranking-name">{colaborador.nome}</span>
                  <div className="ranking-stats">
                    <span>{colaborador.presencas} presenças</span>
                    <span className="percentage">{colaborador.percentual}%</span>
                  </div>
                </div>
                <div className="progress-bar">
                  <div 
                    className="progress-fill" 
                    style={{ width: `${colaborador.percentual}%` }}
                  ></div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Reuniões Mais Frequentadas */}
        <div className="reunioes-card">
          <h3>Reuniões Mais Frequentadas</h3>
          <div className="reunioes-list">
            {relatorios.reunioesMaisFrequentadas.length === 0 ? (
              <p className="sem-dados">Nenhuma reunião com presenças no período.</p>
            ) : (() => {
              const maxMedia = Math.max(1, ...relatorios.reunioesMaisFrequentadas.map(r => r.media));
              return relatorios.reunioesMaisFrequentadas.map((reuniao, index) => (
                <div key={index} className="reuniao-item">
                  <div className="reuniao-info">
                    <span className="reuniao-tipo">{reuniao.tipo}</span>
                    <div className="reuniao-stats">
                      <span>Média: {reuniao.media} pessoas</span>
                      <span>Total: {reuniao.total} presenças</span>
                    </div>
                  </div>
                  <div className="reuniao-chart">
                    <div
                      className="reuniao-bar"
                      style={{ width: `${(reuniao.media / maxMedia) * 100}%` }}
                    />
                  </div>
                </div>
              ));
            })()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RelatorioPresencas;